import React from 'react'
import {connect} from "react-redux";
import {send_booster_cmd} from "../etc/cmd";

const Booster = ({booster, dccgen}) => {
    const booster_state = parseInt(booster.boost_stat | 0)

    let st = (booster_state < 0x80)?"off":"on";

    let current = booster.BIDIB_BST_DIAG_I
    if (current < 64) {
        current = (current - 12) * 4
    } else if (current < 128) {
        current = (current - 51) * 16
    } else if (current < 192) {
        current = (current - 108) * 64
    } else if (current < 251) {
        current = (current - 171) * 256
    }
    const voltage = booster.BIDIB_BST_DIAG_V / 10.0
    const temperature = booster.BIDIB_BST_DIAG_T

    let offreason = ""
    if(booster_state === 0x01) {
        offreason = " shortcut";
    }

    function onBoosterClick() {
        let cc = {
            id: booster.uid,
            state: (booster_state < 0x80)
        }
        send_booster_cmd(cc);
    }

    return (
        <>
            <div title={'Booster ' + booster.uid + " (" + booster.product + ")"} key={booster.uid} className={"bubble dcc booster " + st + offreason}
                onClick={onBoosterClick}
            >
                {current}mA&nbsp;
                {voltage}V&nbsp;
                {temperature}°C
            </div>
        < />);
}

function mapStateToProps(state, other) {
    return state;
}

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(Booster)